import { IconPlus, SequenceMenu, GreyGrey60 } from '@sequencehq/core-components'
import { useSetAtom } from 'jotai'
import { usePhase } from '../../utils/usePhase'
import { taskDrawerConfigAtom } from '../../../../../atoms'

export const PhaseAddEntityKebabMenu = (props: { phaseId: string }) => {
  const setDrawer = useSetAtom(taskDrawerConfigAtom)
  const { phase } = usePhase(props.phaseId)

  return (
    <SequenceMenu
      data-testid={`reviewPricing.phase.${phase.id}.addMenu`}
      variant="ghost"
      buttonSize="small"
      alignment="bottom-right"
      buttonIcon={<IconPlus color={GreyGrey60} />}
      items={[
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            data-testid={`reviewPricing.phase.${phase.id}.addMenu.product`}
            key="addProduct"
            uuid="add-product"
            label="Add product"
            onClick={() => {
              setDrawer({
                type: 'PRICE',
                phaseId: props.phaseId,
                priceId: undefined
              })

              setIsOpen?.(false)
            }}
          />
        ),
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            data-testid={`reviewPricing.phase.${phase.id}.addMenu.discount`}
            key="addDiscount"
            uuid="add-discount"
            label="Add discount"
            isDisabled={!phase.availableFeatures.addDiscount}
            onClick={() => {
              setDrawer({
                type: 'DISCOUNT',
                phaseId: props.phaseId,
                discountId: undefined
              })

              setIsOpen?.(false)
            }}
          />
        ),
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            data-testid={`reviewPricing.phase.${phase.id}.addMenu.minimum`}
            key="addMinimum"
            uuid="add-minimum"
            label="Add minimum"
            isDisabled={!phase.availableFeatures.addMinimum}
            onClick={() => {
              setDrawer({
                type: 'MINIMUM',
                phaseId: props.phaseId,
                minimumId: undefined
              })

              setIsOpen?.(false)
            }}
          />
        )
      ]}
    />
  )
}
